







import Vue from 'vue'
import UiTag from '@/components/Ui/Tag/Tag.vue'
import Resp from '@/models/resp/Resp'

export default Vue.extend({
  props: {
    status: String,
    resp: Object as () => Resp
  },
  components: {
    UiTag
  }
})
